export default function({language}) {
    var config = {
        label: language["date-label"],
        placeholder: 'ddmmåå',
        format: "integer",
        maxLength: 6,
        validators: ["mandatory", "minDigits:6"],
    };

    return {
        config,
        extendsType: "text-field",
        validators: [
            function checkDate(state, config) {
                if (validateDate(state.value, config)) return false;
                else return language["date-invalid"];
            }
        ]
    };
};


function validateDate(number, config) {
    const dateMonthYear = config.placeholder === "ddmmåå" || config.placeholder === "ddmmyy";
    const yearMonthDate = config.placeholder === "ååmmdd";

    if (dateMonthYear || yearMonthDate) {
        let day;
        let month;

        if (yearMonthDate) {
            day = number.slice(4, 6);
            month = number.slice(2, 4);
        }
        if (dateMonthYear) {
            day = number.slice(0, 2);
            month = number.slice(2, 4);
        }

        return (
            number.length === 6 &&
            day > 0 && day <= 31 &&
            month > 0 && month <= 12
        );
    } else {
        return true;
    }
};

